import * as React from "react";
import TimeHelper from "util/TimeHelper";
import connect from "stores/connect";
import MetricsExtractor from "logic/metrics/MetricsExtractor";
import { MetricsActions, MetricsStore } from "stores/metrics/MetricsStore";
class MetricContainer extends React.Component {
  componentDidMount() {
    const { name } = this.props;
    MetricsActions.addGlobal(name);
  }
  shouldComponentUpdate(nextProps) {
    const { metricsUpdatedAt } = this.props;
    if (metricsUpdatedAt !== null && nextProps.metricsUpdatedAt) {
      return nextProps.metricsUpdatedAt > metricsUpdatedAt;
    }
    return true;
  }
  componentWillUnmount() {
    const { name } = this.props;
    MetricsActions.removeGlobal(name);
  }
  render() {
    const { children, metrics, name: fullName, zeroOnMissing } = this.props;
    if (!metrics) {
      return /* @__PURE__ */ React.createElement("span", null, "Loading...");
    }
    let throughput = Object.keys(metrics).map((nodeId) => MetricsExtractor.getValuesForNode(metrics[nodeId], { throughput: fullName })).reduce(
      (accumulator, currentMetric) => ({ throughput: (accumulator.throughput || 0) + (currentMetric.throughput || 0) }),
      {}
    );
    if (zeroOnMissing && (!throughput || !throughput.throughput)) {
      throughput = { throughput: 0 };
    }
    return /* @__PURE__ */ React.createElement("div", null, React.Children.map(
      children,
      (child) => React.cloneElement(child, { metric: { full_name: fullName, count: throughput.throughput } })
    ));
  }
}
MetricContainer.defaultProps = {
  zeroOnMissing: true
};
export default connect(
  MetricContainer,
  { metricsStore: MetricsStore },
  ({ metricsStore, ...otherProps }) => {
    var _a;
    return {
      ...otherProps,
      metrics: metricsStore.metrics,
      metricsUpdatedAt: (_a = metricsStore.metricsUpdatedAt) != null ? _a : TimeHelper.nowInSeconds()
    };
  }
);
